/*
 * @Author: liangen liangen@oppo.com
 * @Date: 2022-06-06 14:36:20
 * @LastEditors: liangen liangen@oppo.com
 * @LastEditTime: 2022-06-06 15:34:50
 * @FilePath: /cem-portal-frontend/src/pages/Survey/SurveyManagement/components/SurveyContent/util.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

//获取题目初始化选项
export const getTopicOptions = (arr, prop) => {
  const topicOptions = (arr || []).map(v => v[prop])
  let normalValue = '';
  topicOptions.forEach(element => {
    normalValue += `<p>${element}</p>`;
    // normalValue += element
  });
  return normalValue;
}
/**
 *
 *富文本修改时修改原始数据的数据
 * @param {*} value
 */
export const changeOptionValue = (value, options, childTopicType = 0, matrixValue = []) => {
  let list = value.split('</p>').filter(v => {
    return !!v?.trim() && v.indexOf('<br>') === -1
  })

  //如果list的length 小于 state.editItem.topicOptionSetting的length,说明进行了删除，暂时春删除，后面优化
  if (list.length < options.length) {
    options.splice(list.length - 1, options.length - list.length)
  }
  list.forEach((element, index) => {
    if (index + 1 > options.length) {
      if (childTopicType) {
        options.push({
          topicId: '', //题目ID
          topicName: element + '</p>', // 题目名称
          topicType: childTopicType //题目类型
        })
      } else {
        options.push({
          optionName: element + '</p>', //选项name
          optionId: '', //选项ID
          isAddText: false, //是否允许填空
          isEncryption: false,
          isRequire: false, //是否必填
          format: '', //填空格式，枚举示例（number：数字、letter：字母、chinese：中文、email：Email、phone：手机号码）
          isFixedNo: false, //是否固定选项
        })
      }
    } else {
      if (childTopicType) {
        options[index].topicName = element + '</p>';
      } else {
        options[index].optionName = element + '</p>';
      }
    }
    // console.log('changeOptionValue', options)
  });
}

//默认值的给定
export const getNormalValue = (initValue, normalValue) => {
  return initValue ? initValue : normalValue;
}

// 选择题选项排序
export const sortByKey = (arr, key) => {
  return arr.sort((a, b) => {
    let x = Number(a[key])
    let y = Number(b[key])
    return x < y ? -1 : x > y ? 1 : 0
  })
}
